import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Field, ErrorMessage } from 'formik';
import { useSelector } from 'react-redux';

const TeamMembersDropdown = ({
  teamMembersList,
  handleChange,
  handleTeamMemberChange = () => {},
  // To confirm if dropdown change will affect any other fields on the same form
  // For Eg: timesheet page team members dropdown change will re-render project list field
  isDependentFiled,
  // Is field validation is required
  isValidate,
  isAllOptionRequired,
  isUpdatingTeamsList,
  defaultPlaceholder,
  fieldName,
  isRequired,
  fieldLabel,
}) => {
  const permissions = useSelector((state) => state.permissionsReducer);
  // Team members list
  const teamMembers = teamMembersList
    .sort((a, b) => (a.firstName > b.firstName ? 1 : -1))
    .map((member, index) => (
      <option key={index} value={member.userId}>
        {member.lastName
          ? `${member.firstName} ${member.lastName}`
          : member.firstName}
        {member.employeeId ? ` (${member.employeeId})` : ''}
        {member.status === 'inactive' && ' (Inactive)'}
      </option>
    ));
  const userData = JSON.parse(localStorage.getItem('USER_DATA'));
  const label = fieldLabel || 'Team members';

  return (
    <Form.Group controlId="TeamMembers">
      <Form.Label>
        {label} {isRequired && <span className="text-danger">*</span>}
      </Form.Label>
      {permissions && permissions.includes('team_member_view') ? (
        <>
          {isDependentFiled ? (
            <>
              <Field
                className="form-select"
                as="select"
                name={fieldName || 'teamMember'}
                onChange={(e) => {
                  handleChange(e);
                  setTimeout(() => {
                    handleTeamMemberChange(e);
                  }, 0);
                }}
                disabled={isUpdatingTeamsList}
              >
                {isValidate ? (
                  <option value="">Select a Team Member</option>
                ) : (
                  <option value="all">All</option>
                )}
                {defaultPlaceholder && (
                  <option value="">{defaultPlaceholder}</option>
                )}
                {teamMembers}
              </Field>
              <ErrorMessage
                name={fieldName || 'teamMember'}
                render={(msg) => <small className="text-danger">{msg}</small>}
              />
            </>
          ) : (
            <Field
              className="form-select"
              as="select"
              name={fieldName || 'teamMember'}
            >
              {isAllOptionRequired && <option value="all">All</option>}
              {defaultPlaceholder && (
                <option value="">{defaultPlaceholder}</option>
              )}
              {teamMembers}
            </Field>
          )}
        </>
      ) : (
        <Field
          className="form-select"
          as="select"
          name={fieldName || 'teamMember'}
          disabled={isUpdatingTeamsList}
        >
          <option key={0} value={userData._id}>
            {userData.lastName
              ? `${userData.firstName} ${userData.lastName}`
              : userData.firstName}
          </option>
        </Field>
      )}
    </Form.Group>
  );
};

TeamMembersDropdown.propTypes = {
  teamMembersList: PropTypes.array,
  handleChange: PropTypes.func,
  handleTeamMemberChange: PropTypes.func,
  isDependentFiled: PropTypes.bool,
  isValidate: PropTypes.bool,
  isAllOptionRequired: PropTypes.bool,
  isUpdatingTeamsList: PropTypes.bool,
  fieldName: PropTypes.string,
  isRequired: PropTypes.bool,
  defaultPlaceholder: PropTypes.string,
  fieldLabel: PropTypes.string,
};

export default TeamMembersDropdown;
